var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};

export { compareByDepth };
